import Contact from "#components/Contact";
import { CaseStudyDetail } from "#sections/CaseStudyDetail";
import React from "react";

function CaseStudyDetailPage() {
    return (
        <>
            <CaseStudyDetail />
            <Contact />
        </>
    );
}
export default CaseStudyDetailPage;
